import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
  click: Function,
  nameIcon: {
    type: String,
    required: true
  },
  descricao: {
    type: String,
    required: false
  },
  sizeIcon: {
    type: String,
    required: false,
  },
  colorIcon: {
    type: String,
    required: false
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _directive_tippy = _resolveDirective("tippy")!

  return _withDirectives((_openBlock(), _createBlock(_component_mdicon, {
    size: __props.sizeIcon,
    style: _normalizeStyle('color:' + __props.colorIcon),
    name: __props.nameIcon,
    onclick: __props.click
  }, null, 8, ["size", "style", "name", "onclick"])), [
    [_directive_tippy, { content: __props.descricao }]
  ])
}
}

})